import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconTelegram = t0 => {
  const $ = _c(11);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <g clipPath="url(#Icon_Telegram_svg__a)"><path fill="currentColor" d="M62.96.613A2.8 2.8 0 0 0 59.92.32L2.213 31.067a4.107 4.107 0 0 0 .454 7.44l8.693 3.68c-.04.22-.04.446 0 .666l6.667 17.974a4.853 4.853 0 0 0 7.813 1.92l9.067-10.027a.69.69 0 0 1 .773-.16l8.4 3.573a4.35 4.35 0 0 0 3.467 0 4.08 4.08 0 0 0 2.213-2.666l14.24-50A2.67 2.67 0 0 0 62.96.613M15.573 42.8l25.84-21.467a.615.615 0 0 1 .907 0 .588.588 0 0 1 0 .88L23.067 45.84a2 2 0 0 0-.427.933l-1.68 10.534z" /></g>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <defs><clipPath id="Icon_Telegram_svg__a"><path fill="currentColor" d="M0 0h64v64H0z" /></clipPath></defs>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== props || $[8] !== t1 || $[9] !== t2) {
    t5 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}{t4}</svg>;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
IconTelegram.displayName = 'IconTelegram';